const state = {
    locationDescription: null,
    locationImage: null,
    searchQueryLocation: null,
};

export default state;